import type { IconData } from '@stacksjs/iconify-core'

export const virtualRealitySolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 7.5c-8.419 0-13.694.483-16.774.93c-2.874.416-4.89 2.7-5.184 5.495C1.777 16.448 1.5 20.221 1.5 25s.277 8.552.542 11.075c.295 2.795 2.31 5.079 5.184 5.495c1.68.244 4.01.498 7.144.679a5.44 5.44 0 0 0 3.707-1.19l3.764-3.012a2.5 2.5 0 0 1 1.562-.547h1.194a2.5 2.5 0 0 1 1.562.547l3.764 3.012a5.44 5.44 0 0 0 3.707 1.19c3.134-.18 5.465-.435 7.144-.678c2.874-.417 4.89-2.701 5.184-5.496c.265-2.523.542-6.296.542-11.075s-.277-8.552-.542-11.075c-.295-2.795-2.31-5.079-5.184-5.496C37.694 7.983 32.42 7.5 24 7.5m-10 10a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13m20 0a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default virtualRealitySolid
